// extracted by mini-css-extract-plugin
export var arrow = "CollectionCard-module--arrow--0c183";
export var arrowNo = "CollectionCard-module--arrow_no--12bde";
export var arrowYes = "CollectionCard-module--arrow_yes--c581b";
export var corner = "CollectionCard-module--corner--70269";
export var documentCard = "CollectionCard-module--documentCard--11932";
export var flex = "CollectionCard-module--flex--d9293";
export var flex1 = "CollectionCard-module--flex_1--e5f5a";
export var flexCenter = "CollectionCard-module--flex_center--62e48";
export var flexCenterCol = "CollectionCard-module--flex_center_col--134bf";
export var flexCol = "CollectionCard-module--flex_col--5e212";
export var flexFixCenterCol = "CollectionCard-module--flex_fix_center_col--1ef28";
export var flexFixedCenterCol = "CollectionCard-module--flex_fixed_center_col--3487a";
export var image = "CollectionCard-module--image--5ce81";
export var libraryButton = "CollectionCard-module--libraryButton--409d9";
export var libraryIcon = "CollectionCard-module--libraryIcon--0403c";
export var linkButton = "CollectionCard-module--linkButton--e9343";
export var moreButton = "CollectionCard-module--moreButton--2def2";
export var overlay = "CollectionCard-module--overlay--72c5e";
export var overlayBottomRow = "CollectionCard-module--overlayBottomRow--f6796";
export var overlayContentType = "CollectionCard-module--overlayContentType--39d61";
export var overlayTopRow = "CollectionCard-module--overlayTopRow--36d36";
export var publishingContainer = "CollectionCard-module--publishingContainer--2f7fa";
export var publishingInformationLabel = "CollectionCard-module--publishingInformationLabel--5eeb0";
export var rotating = "CollectionCard-module--rotating--8bc0c";
export var title = "CollectionCard-module--title--d47b2";